import Link from "next/link";

const tools = [
  { id: "tyre-size-calculator", title: "Tyre Size Calculator" },
  { id: "wheel-size-visualizer", title: "Wheel Size Visualizer" },
  { id: "tyre-pressure-calculator", title: "Tyre Pressure Calculator" },
  { id: "tyre-expiry-date-calculator", title: "Tyre Expiry Date Calculator" },
  { id: "wheel-mag-pitch-circle-diameter-size-calculator", title: "Wheel PCD Calculator" },
  { id: "vehicle-battery-size-calculator", title: "Vehicle Battery Size Calculator" },
  { id: "spark-plug-size-for-vehicle", title: "Spark Plug Size Calculator" },
  { id: "brake-pads-vehicle-calculator", title: "Brake Pads Vehicle Calculator" },
  { id: "service-kit-for-vehicle", title: "Service Kit for Vehicle" },
  { id: "turbo-size-calculator", title: "Turbo Size Calculator" },
  { id: "chip-tuning-unit-for-diesel-and-petrol", title: "Chip Tuning Unit for Diesel & Petrol" },
  { id: "vehicle-diagnosis-quiz", title: "Vehicle Diagnosis Quiz" },
  { id: "vehicle-performance-upgrade-quiz", title: "Vehicle Performance Upgrade Quiz" },
];

const basePath = "/online-automotive-calculators-and-tools";

export default function RelatedCalculators({ currentToolId }: { currentToolId: string }) {
  const headingId = `${currentToolId}-related-tools-title`;

  return (
    <nav className="mx-auto my-8 w-full max-w-6xl rounded-2xl border border-slate-200 bg-white p-4 text-slate-900 sm:p-6" aria-labelledby={headingId}>
      <h2 id={headingId} className="text-2xl font-bold">Related calculators and tools</h2>
      <p className="mt-3 text-slate-600">Explore our other free automotive calculators to compare specifications and plan your next vehicle service or upgrade.</p>
      <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {tools.filter((tool) => tool.id !== currentToolId).map((tool) => (
          <li key={tool.id}>
            <Link
              href={`${basePath}/${tool.id}`}
              className="block h-full rounded-lg border border-slate-200 px-4 py-3 font-medium text-blue-700 underline decoration-blue-200 underline-offset-4 transition-colors hover:border-blue-300 hover:bg-blue-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
            >
              {tool.title}
            </Link>
          </li>
        ))}
      </ul>
      <Link href={`${basePath}/online-automotive-calculators-and-tools-list`} className="mt-5 inline-block font-semibold text-blue-700 underline">
        View all automotive calculators and tools
      </Link>
    </nav>
  );
}
